export const environment = {
  production: false,
  // Same-origin as the SPA (served by the Apache vhost over HTTPS) so the Secure HttpOnly
  // auth cookie works. Apache proxies /api to the backend.
  api_url: 'https://hema.sandbox.invento.io/api',

  firebaseConfig: {
    apiKey: 'AIzaSyBubwjWzlq1a5VAZw9PGHSfp_zPzFR-4mw',
    authDomain: 'invento-hema.firebaseapp.com',
    projectId: 'invento-hema',
    messagingSenderId: '1069066692015',
    appId: '1:1069066692015:web:b48ca5360d91c0764d7b5a',
    measurementId: 'G-FGCERLS1JC',
    vapidKey:
      'BOfEw2gp4NfTmW0jNVIL0FHLC9OWwVDdD5kxOyQqJ0FmdgN7M9YPc40sMcHFD5QBRqesLjUCWBC75Bo6V4A4V_g'
  }
}
